const isServerSide = typeof window === 'undefined'

interface SearchHistoryManager {
  getSearchHistory: () => string[]
  addSearchHistory: (newHistory: string) => void
  removeSearchHistory: (value: string) => void
}

export function createSearchHistoryManager(keyPath = ''): SearchHistoryManager {
  const historyPath = keyPath || 'search_history'

  // 获取搜索历史
  const getSearchHistory = (): string[] => {
    if (isServerSide) {
      return []
    }
    try {
      const storedHistories = localStorage.getItem(historyPath)
      return storedHistories ? JSON.parse(storedHistories) : []
    } catch (error) {
      console.error('Error getting search history:', error)
      return []
    }
  }

  // 保存搜索历史
  const saveSearchHistory = (histories: string[]): void => {
    if (!isServerSide) {
      try {
        localStorage.setItem(historyPath, JSON.stringify(histories))
      } catch (error) {
        console.error('Error saving search history:', error)
      }
    }
  }

  // 添加搜索历史
  const addSearchHistory = (newHistory: string): void => {
    if (!newHistory?.length) {
      return
    }

    const currentHistories = getSearchHistory()
    const currentIndex = currentHistories.indexOf(newHistory)

    let newHistories: string[]

    if (currentIndex === 0) {
      return
    } else if (currentIndex > 0) {
      // 如果存在则移到首位
      newHistories = [
        newHistory,
        ...currentHistories.slice(0, currentIndex),
        ...currentHistories.slice(currentIndex + 1)
      ]
    } else {
      // 添加新记录并限制最大数量为10
      newHistories = [newHistory, ...currentHistories].slice(0, 10)
    }

    saveSearchHistory(newHistories)
  }

  // 移除搜索历史
  const removeSearchHistory = (value: string): void => {
    try {
      const currentHistories = getSearchHistory()
      const newHistories = currentHistories.filter(item => item !== value)
      saveSearchHistory(newHistories)
    } catch (error) {
      console.error('Error removing search history:', error)
    }
  }

  return {
    getSearchHistory,
    addSearchHistory,
    removeSearchHistory
  }
}


// import { createSearchHistoryManager } from './searchHistory'
// const searchManager = createSearchHistoryManager('custom_key')
// searchManager.addHistory('搜索词')
// const history = searchManager.getSearchHistory()
// searchManager.removeHistory('要删除的搜索词')
